import * as React from 'react';

import Paper from '@mui/material/Paper';

import Table from '@mui/material/Table';

import { useTheme } from '@mui/material/styles';

import TableBody from '@mui/material/TableBody';

import TableCell from '@mui/material/TableCell';

import TableContainer from '@mui/material/TableContainer';

import TableHead from '@mui/material/TableHead';

import TablePagination from '@mui/material/TablePagination';

import TableRow from '@mui/material/TableRow';

import IconButton from '@mui/material/IconButton';

import Menu from '@mui/material/Menu';

import MenuItem from '@mui/material/MenuItem';

import MoreVertIcon from '@mui/icons-material/MoreVert';

const columns = [
	{ id: 'name', label: 'Role Name', minWidth: 170 },
	{ id: 'date', label: 'Created Date', minWidth: 170 },
	{
		id: 'createdBy',
		label: 'Created By',
		// flex: 1,
		minWidth: 170,
		align: 'right',
		format: (value) => value.toLocaleString('en-US'),
	},
	{
		id: 'modifiedBy',
		label: 'Modfied By',
		minWidth: 170,
		// flex: 1,
		align: 'right',
		format: (value) => value.toLocaleString('en-US'),
	},
	{
		id: 'status',
		label: 'Status',
		minWidth: 170,
		// flex: 1,
		align: 'center',
		format: (value) => value.toFixed(2),
	},
];

function createData(name, date, createdBy, modifiedBy, status) {
	return { name, date, createdBy, modifiedBy, status };
}

const rows = [
	createData('Biller', '12/02/2023', 'M Hasan', 'Hasan', 'Active'),
	createData('Biller', '12/02/2023', 'M Hasan', 'Hasan', 'Active'),
	createData('CEO', '12/02/2023', 'M Hasan', 'Hasan', 'Active'),
	createData('IT Manager', '12/02/2023', 'M Hasan', 'Hasan', 'Active'),
	createData('Biller', '12/02/2023', 'M Hasan', 'Hasan', 'Active'),
	createData('Biller', '12/02/2023', 'M Hasan', 'Hasan', 'inactive'),
	createData('Biller', '12/02/2023', 'M Hasan', 'Hasan', 'inactive'),
	createData('Biller', '12/02/2023', 'M Hasan', 'Hasan', 'inactive'),
	createData('Biller', '12/02/2023', 'M Hasan', 'Hasan', 'inactive'),
];

function AllUsers() {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(9);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	return (
		<div style={{ overflowX: 'auto' }}>
			<Paper sx={{ width: '100%' }}>
				<TableContainer
					sx={{
						maxHeight: 440,
						// 	lg: 430,
						// 	sm: 440,
						// 	md: 450,
						// 	xs: 430,
						// 	xl: 550,
						// },
						// '@media only screen and (max-width: 1920px) and (min-width: 1760px)':
						// 	{
						// 		// Styles for xs and sm screens
						// 		height: '650px',
						// 	},
					}}
				>
					<Table stickyHeader aria-label="sticky table">
						<TableHead>
							<TableRow>
								{columns.map((column) => (
									<TableCell
										key={column.id}
										align={column.align}
										style={{
											minWidth: column.minWidth,
											color: '#5B5C5C',
											background: '#EEF5FFCC',
											fontFamily: 'Poppins',
											fontWeight: '500',
										}}
									>
										{column.label}
									</TableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{rows
								.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
								.map((row, index) => (
									<TableRow key={index}>
										{columns.map((column) => {
											const value = row[column.id];

											return (
												<TableCell
													key={column.id}
													align={column.align}
													style={{
														fontFamily: 'Poppins',
														fontSize: '14px',
														fontWeight: '400',
														lineHeight: '21px',
														paddingTop: '0px',
														paddingBottom: '0px',
													}}
												>
													{column.format && typeof value === 'number' ? (
														column.format(value)
													) : column.id === 'status' ? (
														<React.Fragment>
															<span
																style={{
																	color:
																		value === 'Active' ? '#3EAE4D' : '#9C9C9C',
																}}
															>
																{value}
															</span>
															<IconButton
																aria-controls={open ? 'long-menu' : undefined}
																aria-expanded={open ? 'true' : undefined}
																onClick={handleClick}
															>
																<MoreVertIcon />
															</IconButton>
															<Menu
																id="long-menu"
																anchorEl={anchorEl}
																open={open}
																onClose={handleClose}
																PaperProps={{
																	elevation: 0,
																	style: {
																		boxShadow: '0px 1px 1px 0px #00000040',
																		borderRadius: '10px',
																	},
																}}
															>
																<MenuItem
																	style={{
																		color: 'black',
																		fontFamily: 'Poppins',
																		fontSize: '13px',
																	}}
																	onClick={handleClose}
																>
																	Edit
																</MenuItem>
																<MenuItem
																	style={{
																		color: 'red',
																		fontFamily: 'Poppins',
																		fontSize: '13px',
																	}}
																	onClick={handleClose}
																>
																	Delete
																</MenuItem>
															</Menu>
														</React.Fragment>
													) : (
														value
													)}
												</TableCell>
											);
										})}
									</TableRow>
								))}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[9, 25, 100]}
					component="div"
					count={rows.length}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
					labelRowsPerPage={
						<span
							style={{
								fontWeight: '500', // Custom font weight
								color: 'black',
								fontFamily: 'Poppins',
							}}
						>
							Entities per page
						</span>
					}
					style={{
						background: '#EEF5FFCC',
					}}
					SelectProps={{
						style: {
							color: 'black', // Text color for the options
							border: '1px solid black', // Border style for the options
							borderRadius: '4px',
						},
					}}
				/>
			</Paper>
		</div>
	);
}

export default AllUsers;
